export enum RepresentmentFrequencyRuleEnum {
  'NA' = 0,
  '2 Day Tracking' = 1,
  '4 Day Tracking' = 2,
  '5 Day Tracking' = 3,
  '6 Day Tracking' = 4,
  '8 Day Tracking' = 5,
  '9 Day Tracking' = 6,
  '10 Day Tracking' = 7,
  'No Tracking' = 12,
  'One Day Tracking' = 13,
  '3 Day Tracking' = 14,
  '7 Day Tracking' = 15,
  '14 Day Tracking' = 16,
  '21 Day Tracking' = 17,
  '32 Day Tracking' = 18,
  '365 Day Tracking' = 99,
  'Calendar Month' = 98,

}

export namespace RepresentmentFrequencyRuleEnum {
  export function values() {
    return Object.keys(RepresentmentFrequencyRuleEnum).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
